export default __webpack_public_path__ + "static/media/home-search-services.ad640868.jpg";